export class BookingError extends Error {
  constructor(
    message: string,
    public code: string,
    public recoverable: boolean
  ) {
    super(message);
    this.name = 'BookingError';
  }
}

export const BOOKING_ERROR_CODES = {
  MAX_TICKETS_EXCEEDED: 'MAX_TICKETS_EXCEEDED',
  INSUFFICIENT_TICKETS: 'INSUFFICIENT_TICKETS',
  EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
  INVALID_TICKET_TIER: 'INVALID_TICKET_TIER',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  DUPLICATE_BOOKING: 'DUPLICATE_BOOKING',
  USER_NOT_AUTHENTICATED: 'USER_NOT_AUTHENTICATED',
  BOOKING_NOT_FOUND: 'BOOKING_NOT_FOUND',
  CANCELLATION_NOT_ALLOWED: 'CANCELLATION_NOT_ALLOWED',
  SYSTEM_OPTIMIZATION: 'SYSTEM_OPTIMIZATION'
} as const;

export const getBookingErrorMessage = (error: unknown): string => {
  if (error instanceof BookingError) {
    return error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred. Please try again.';
}; 